import { render, staticRenderFns } from "./CreateTickets.vue?vue&type=template&id=3b7dbabd&"
import script from "./CreateTickets.vue?vue&type=script&lang=js&"
export * from "./CreateTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports